exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-backdrop.blur {\n  background-color: rgba(0, 0, 0, 0.9); }\n\n.modal .modal-dialog {\n  max-width: 40%; }\n\n.modal h2 {\n  color: #7091c5; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.scss
// module id = 399
// module chunks = 0